export const NumberFormat = (num = 0) => {
   const thousand = new Intl.NumberFormat('id').format(parseInt(num));
   return 'Rp ' + thousand;
};